import { CommandType } from "../../../../common/services/cqs/CommandType";
import { Leveransplan } from "../../models/leveransvirkesplan-models";
import { LeveransplanCommandBase } from "./LeveransplanCommandBase";

export class RemoveLeveransplanCommand extends LeveransplanCommandBase {
    readonly id: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "RemoveLeveransplanCommand";

    constructor(leveransplan: Leveransplan) {
        super(leveransplan.virkeskostnadGUID, leveransplan.period, RemoveLeveransplanCommand.$type, CommandType.Delete);
        this.id = leveransplan.id;
    }
}
